import { qs, qsa, esc } from "../inc/dom.js";

const initFilterDrawer = () => {
    const drawer = document.getElementById("lpFilterDrawer");
    const openBtn = document.getElementById("lpFilterOpen");
    if (!drawer || !openBtn) return;
    const overlay = document.getElementById("lpFilterOverlay");
    const closeBtn = document.getElementById("lpFilterClose");
    const open = () => {
        document.dispatchEvent(new CustomEvent("oi:drawer-open", { detail: { source: "filter" } }));
        drawer.classList.add("open");
        if (overlay) overlay.classList.add("open");
        openBtn.setAttribute("aria-expanded", "true");
    };
    const close = () => {
        drawer.classList.remove("open");
        if (overlay) overlay.classList.remove("open");
        openBtn.setAttribute("aria-expanded", "false");
    };
    openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && drawer.classList.contains("open")) close();
    });
    document.addEventListener("oi:drawer-open", (e) => {
        if (e.detail && e.detail.source !== "filter" && drawer.classList.contains("open")) close();
    });
};

const initGallery = () => {
    const root = qs("[data-pg]");
    if (!root) return;

    const api = root.getAttribute("data-pg-api");
    const grid = qs("[data-pg-grid]", root);
    const countEl = qs("[data-pg-count]", root);
    const chipsEl = qs("[data-pg-chips]", root);
    const emptyEl = qs("[data-pg-empty]", root);
    const moreBtn = qs("[data-pg-more]", root);
    const groupsEl = qs("[data-pg-groups]", root);
    const badgeEl = qs("[data-pg-badge]", root);
    const planDD = qs("[data-pg-plan-dd]", root);
    const planToggle = qs("[data-pg-plan-toggle]", root);
    const planValue = qs("[data-pg-plan-value]", root);
    const planMenu = qs("[data-pg-plan-menu]", root);
    const resetBtn = qs("[data-pg-reset]", root);
    const searchInput = qs("[data-pg-search]", root);
    const loaderEl = qs("[data-pg-loader]", root);

    const heartOutline = root.getAttribute("data-pg-heart") || "";
    const heartSolid = root.getAttribute("data-pg-heart-solid") || "";

    const state = {
        mpid: root.getAttribute("data-pg-mpid") || "",
        favorites: root.getAttribute("data-pg-favorites") === "1",
        next: root.getAttribute("data-pg-next") || "",
        total: parseInt(root.getAttribute("data-pg-total") || "0", 10),
        perPage: parseInt(root.getAttribute("data-pg-per-page") || "0", 10),
        shown: grid ? qsa(".pg-tile", grid).length : 0,
        loading: false,
    };

    const watchImages = (scope) => {
        qsa(".pg-tile-img", scope).forEach((img) => {
            const tile = img.closest(".pg-tile");
            if (!tile || img.dataset.pgWatched) return;
            img.dataset.pgWatched = "1";
            if (img.complete) {
                tile.classList.remove("is-pending");
                return;
            }
            tile.classList.add("is-pending");
            const done = () => tile.classList.remove("is-pending");
            img.addEventListener("load", done, { once: true });
            img.addEventListener("error", done, { once: true });
        });
    };

    const addSkeletons = () => {
        const count = Math.min(state.perPage, Math.max(state.total - state.shown, 0));
        grid.insertAdjacentHTML(
            "beforeend",
            '<div class="pg-tile pg-tile--skeleton" aria-hidden="true"></div>'.repeat(count)
        );
    };

    const removeSkeletons = () => qsa(".pg-tile--skeleton", grid).forEach((el) => el.remove());

    const selectedTags = () => qsa("[data-pg-tag]", root).filter((i) => i.checked).map((i) => i.value);

    const tileHtml = (asset) => {
        const mp = asset.masterplan || {};
        const bits = ["<div class='pg-lb'>"];
        if (mp.name) {
            bits.push(`<a class='pg-lb-plan' href='${esc(mp.url)}'>The ${esc(mp.name)} <i class='pg-lb-arrow fa-light fa-arrow-right'></i></a>`);
        }
        if (asset.room) bits.push(`<span class='pg-lb-room'>${esc(asset.room)}</span>`);
        if (asset.tags && asset.tags.length) {
            bits.push("<span class='pg-lb-tags'>");
            asset.tags.forEach((tag) => bits.push(`<span class='pg-lb-tag'>${esc(tag.text)}</span>`));
            bits.push("</span>");
        }
        bits.push("</div>");
        return `<div class="pg-tile" data-pg-tile="${esc(asset.id)}"><a class="pg-tile-link" href="${esc(asset.img_hd)}" data-fancybox="pg" data-caption="${bits.join("")}"><img class="pg-tile-img" src="${esc(asset.thumbnail)}" alt="${esc(asset.alt)}" loading="lazy"></a><button style="display:none;" class="btn-favorite oi-login-required pg-fav" data-oi-user-action="favorite" data-oi-user-favorite-state="0" data-homefiniti-id="${esc(asset.homefiniti_id)}"><span class="oi-favorite-state oi-favorite-state-off d-none"><img class="pg-fav-outline" src="${heartOutline}" alt=""><span class="visually-hidden">Add to Favorites</span></span><span class="oi-favorite-state oi-favorite-state-on d-none"><img class="pg-fav-solid" src="${heartSolid}" alt=""><span class="visually-hidden">Remove from Favorites</span></span></button></div>`;
    };

    const renderCount = () => {
        if (!countEl) return;
        countEl.textContent = state.total
            ? `Showing ${state.shown} of ${state.total} photos`
            : "No photos found";
    };

    const renderChips = () => {
        if (!chipsEl) return;
        const chips = [];
        if (searchValue()) {
            chips.push(
                `<button type="button" class="pg-chip" data-pg-chip-search>&ldquo;${esc(searchValue())}&rdquo;<i class="fa-light fa-xmark"></i></button>`
            );
        }
        if (state.mpid) {
            const opt = planMenu && qs(`.pg-select-opt[data-value="${state.mpid}"]`, planMenu);
            chips.push(
                `<button type="button" class="pg-chip" data-pg-chip-plan>${esc(opt ? opt.textContent : "Plan")}<i class="fa-light fa-xmark"></i></button>`
            );
        }
        qsa("[data-pg-tag]", root)
            .filter((i) => i.checked)
            .forEach((input) => {
                const label = qs(".pg-opt-text", input.closest(".pg-opt"));
                chips.push(
                    `<button type="button" class="pg-chip" data-pg-chip-tag="${esc(input.value)}">${esc(label ? label.textContent : input.value)}<i class="fa-light fa-xmark"></i></button>`
                );
            });
        chipsEl.innerHTML = chips.join("");
        const count = chips.length;
        if (badgeEl) {
            badgeEl.textContent = String(count);
            badgeEl.hidden = count === 0;
        }
    };

    const renderGroups = (reference) => {
        if (!groupsEl || !reference) return;
        const checked = selectedTags();
        const openSubjects = qsa("[data-pg-group]", groupsEl)
            .filter((g) => g.classList.contains("is-open"))
            .map((g) => g.getAttribute("data-pg-subject"));
        groupsEl.innerHTML = reference
            .map((subject, index) => {
                const items = subject.items
                    .map(
                        (item) =>
                            `<label class="pg-opt"><input type="checkbox" data-pg-tag value="${esc(item.id)}"${checked.indexOf(item.id) > -1 ? " checked" : ""}><span class="pg-opt-text">${esc(item.text)}</span><span class="pg-opt-count">${esc(item.count)}</span></label>`
                    )
                    .join("");
                const isOpen = openSubjects.length
                    ? openSubjects.indexOf(subject.id) > -1
                    : index === 0;
                return `<div class="pg-group${isOpen ? " is-open" : ""}" data-pg-group data-pg-subject="${esc(subject.id)}"><button type="button" class="pg-group-title" data-pg-group-toggle aria-expanded="${isOpen}"><span class="pg-group-label">${esc(subject.text)}</span><span class="pg-group-icon">+</span></button><div class="pg-group-body"><div class="pg-opts">${items}</div></div></div>`;
            })
            .join("");
    };

    const renderPlans = (masterplans) => {
        if (!planMenu || !masterplans) return;
        const opts = [
            `<button type="button" class="pg-select-opt${state.mpid ? "" : " active"}" data-value="" role="option">Any Plan</button>`,
        ];
        masterplans.forEach((mp) => {
            opts.push(
                `<button type="button" class="pg-select-opt${state.mpid === mp.id ? " active" : ""}" data-value="${esc(mp.id)}" role="option">The ${esc(mp.name)}</button>`
            );
        });
        planMenu.innerHTML = opts.join("");
        if (planValue) {
            const active = qs(".pg-select-opt.active", planMenu);
            planValue.textContent = active ? active.textContent : "Any Plan";
        }
    };

    const searchValue = () => (searchInput ? searchInput.value.trim() : "");

    const syncUrl = (tags) => {
        const params = new URLSearchParams();
        if (tags) params.set("tags", tags);
        if (state.mpid) params.set("mpid", state.mpid);
        if (searchValue()) params.set("q", searchValue());
        if (state.favorites) params.set("my_favorites", "true");
        const query = params.toString();
        window.history.replaceState({}, "", query ? `${window.location.pathname}?${query}` : window.location.pathname);
    };

    const load = (append) => {
        if (state.loading || !grid) return;
        state.loading = true;
        if (append) {
            if (moreBtn) moreBtn.classList.add("is-loading");
            addSkeletons();
        } else {
            root.classList.add("is-loading");
            if (loaderEl) loaderEl.hidden = false;
        }
        const tags = selectedTags().join(",");
        const params = new URLSearchParams();
        if (tags) params.set("tags", tags);
        if (state.mpid) params.set("mpid", state.mpid);
        if (searchValue()) params.set("q", searchValue());
        if (state.favorites) params.set("my_favorites", "true");
        params.set("cursor", append ? state.next || "0" : "0");
        if (append) params.set("partial", "1");

        fetch(`${api}?${params.toString()}`, { headers: { "X-Requested-With": "XMLHttpRequest" } })
            .then((res) => res.json())
            .then((json) => {
                const payload = (json && json.data) || {};
                const html = (payload.assets || []).map(tileHtml).join("");
                if (append) {
                    removeSkeletons();
                    grid.insertAdjacentHTML("beforeend", html);
                    state.shown += (payload.assets || []).length;
                } else {
                    grid.innerHTML = html;
                    state.shown = (payload.assets || []).length;
                    renderGroups(payload.reference);
                    renderPlans(payload.masterplans);
                }
                watchImages(grid);
                if (payload.per_page) state.perPage = payload.per_page;
                state.total = payload.total || 0;
                state.next = payload.next_cursor == null ? "" : String(payload.next_cursor);
                if (moreBtn) moreBtn.hidden = !state.next;
                if (emptyEl) emptyEl.hidden = state.total !== 0;
                renderCount();
                renderChips();
                syncUrl(tags);
            })
            .catch(() => {})
            .then(() => {
                state.loading = false;
                removeSkeletons();
                root.classList.remove("is-loading");
                if (loaderEl) loaderEl.hidden = true;
                if (moreBtn) moreBtn.classList.remove("is-loading");
            });
    };

    if (groupsEl) {
        groupsEl.addEventListener("click", (e) => {
            const toggle = e.target.closest("[data-pg-group-toggle]");
            if (!toggle) return;
            const group = toggle.closest("[data-pg-group]");
            const isOpen = group.classList.toggle("is-open");
            toggle.setAttribute("aria-expanded", String(isOpen));
        });
        groupsEl.addEventListener("change", (e) => {
            if (!e.target.matches("[data-pg-tag]")) return;
            load(false);
        });
    }

    if (planDD && planToggle) {
        planToggle.addEventListener("click", (e) => {
            e.stopPropagation();
            const open = planDD.classList.toggle("is-open");
            planToggle.setAttribute("aria-expanded", String(open));
        });
        planDD.addEventListener("click", (e) => {
            const opt = e.target.closest(".pg-select-opt");
            if (!opt) return;
            state.mpid = opt.getAttribute("data-value") || "";
            qsa(".pg-select-opt", planDD).forEach((o) => o.classList.toggle("active", o === opt));
            if (planValue) planValue.textContent = opt.textContent;
            planDD.classList.remove("is-open");
            planToggle.setAttribute("aria-expanded", "false");
            load(false);
        });
        document.addEventListener("click", (e) => {
            if (!planDD.contains(e.target)) {
                planDD.classList.remove("is-open");
                planToggle.setAttribute("aria-expanded", "false");
            }
        });
    }

    if (chipsEl) {
        chipsEl.addEventListener("click", (e) => {
            if (e.target.closest("[data-pg-chip-search]")) {
                if (searchInput) searchInput.value = "";
                load(false);
                return;
            }
            const planChip = e.target.closest("[data-pg-chip-plan]");
            if (planChip) {
                state.mpid = "";
                load(false);
                return;
            }
            const tagChip = e.target.closest("[data-pg-chip-tag]");
            if (!tagChip) return;
            const value = tagChip.getAttribute("data-pg-chip-tag");
            const input = qsa("[data-pg-tag]", root).find((i) => i.value === value);
            if (input) input.checked = false;
            load(false);
        });
    }

    if (moreBtn) moreBtn.addEventListener("click", () => load(true));

    const setEmptyMessage = () => {
        const message = emptyEl && qs("p", emptyEl);
        if (!message) return;
        message.textContent = state.favorites
            ? "You haven't saved any photos yet. Tap the heart on any photo to add it here."
            : "No photos match your current filters. Try adjusting your selections.";
    };

    const isAuthenticated = () => {
        const user = window.oi && window.oi.loaded && window.oi.loaded.user;
        return Boolean(user && user.authenticated);
    };

    const tabs = qsa("[data-pg-tab]", root);
    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            const wantFavorites = tab.getAttribute("data-pg-tab") === "favorites";
            if (wantFavorites && !isAuthenticated()) return;
            if (wantFavorites === state.favorites) return;
            state.favorites = wantFavorites;
            tabs.forEach((btn) => btn.classList.toggle("is-active", btn === tab));
            setEmptyMessage();
            load(false);
        });
    });
    setEmptyMessage();

    window.addEventListener("oiuser_favorites_changed", () => {
        if (state.favorites) load(false);
    });

    if (searchInput) {
        let searchTimer = null;
        let lastSearch = searchValue();
        searchInput.addEventListener("input", () => {
            window.clearTimeout(searchTimer);
            searchTimer = window.setTimeout(() => {
                if (searchValue() === lastSearch) return;
                lastSearch = searchValue();
                load(false);
            }, 350);
        });
        searchInput.addEventListener("keydown", (e) => {
            if (e.key !== "Enter") return;
            e.preventDefault();
            window.clearTimeout(searchTimer);
            lastSearch = searchValue();
            load(false);
        });
    }

    if (resetBtn) {
        resetBtn.addEventListener("click", () => {
            qsa("[data-pg-tag]", root).forEach((i) => {
                i.checked = false;
            });
            state.mpid = "";
            if (searchInput) searchInput.value = "";
            load(false);
        });
    }

    if (grid) watchImages(grid);
    renderChips();
    renderCount();
};

initFilterDrawer();
initGallery();
